import type { NewMessagePayload } from "./pusher-events";

export type ConversationMessageNotificationDestination = "assigned" | "inbox";

/**
 * Routes a new inbound message to the notification surface that owns it.
 * Assigned conversations belong to one agent; unassigned conversations stay
 * visible in the shared Inbox.
 */
export function conversationMessageNotificationDestination(
  payload: Pick<NewMessagePayload, "assigneeUserId">,
  currentUserId: string | null | undefined,
): ConversationMessageNotificationDestination {
  return payload.assigneeUserId && payload.assigneeUserId === currentUserId
    ? "assigned"
    : "inbox";
}